import React from 'react';
import PropTypes from 'prop-types';
import { Nav, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import SubscriptionForm from 'components/subscription/subscriptionForm';
import FindLibraries from 'components/findLibraries/findLibraries';
//styles
import './footer.scss';
//images
import creditCards from 'assets/img/creditcards.png';
import logoMinistry from 'assets/img/logoMinistry.png';

const Footer = ({ helpTextList = [] }) => {
  const { t } = useTranslation(['footer']);
  const location = useLocation();
  const { name, data, is_single_company } = useCompanyStore();
  const { assignedLibrary } = useAssignedLibrary();

  function createMarkup() {
    const text = `Copyright &copy; ${new Date().getFullYear()} ${name}. ${t('todosLosDerechos')}`;
    return {
      __html: text,
    };
  }

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      {!is_single_company && !location.pathname.includes('/mapa') && <FindLibraries />}
      <SubscriptionForm />
      {data && (
        <>
          <div className="footer-links  w-100">
            <div className="container container-responsive mainDiv">
              <Row className="information">
                <Col className="secondSection" xs={8} sm={8} md={3} xl={3} lg={11}>
                  <h5 className="title-footer">{t('sobreNosotros')}</h5>
                  <Nav.Link href={`/${assignedLibrary}/sobre-nosotros`}>
                    <p className="textFooter">{t('aboutus')}</p>
                  </Nav.Link>
                  <Nav.Link href={`/${assignedLibrary}/contacto`}>
                    <p className="textFooter">{t('contact')}</p>
                  </Nav.Link>
                  {!is_single_company && (
                    <Nav.Link href={`/${assignedLibrary}/librerias`}>
                      <p className="textFooter">{t('bookstores')}</p>
                    </Nav.Link>
                  )}
                </Col>
                <Col className="thirdSection" xs={8} sm={8} md={3} xl={3} lg={11}>
                  <h5 className="title-footer">{t('compraConConfianza')}</h5>
                  {helpTextList.map((helpText, index) => (
                    <Nav.Link
                      as={Link}
                      className="help-item-footer mb-1"
                      to={`${assignedLibrary}/ayuda/${helpText.id}/${helpText.slug || ''}`}
                      key={`ayuda-${index}`}
                    >
                      {helpText.title}
                    </Nav.Link>
                  ))}
                </Col>
                <Col className="secondSection" xs={8} sm={8} md={3} xl={3} lg={11}>
                  <h5 className="title-footer">{t('condicionesGenerales')}</h5>
                  <div className="textFooter contact pb-2">
                    <Link
                      className="nav-link"
                      to={`${assignedLibrary}/aviso-legal-y-politica-de-privacidad`}
                      onClick={goUp}
                    >
                      <p className="contactDetails ">{t('legalprivacy')}</p>
                    </Link>
                  </div>
                  <div className="textFooter contact pb-2">
                    <Link to={`${assignedLibrary}/condiciones-de-uso`} className="nav-link" onClick={goUp}>
                      <p className="contactDetails">{t('usageconditions')}</p>
                    </Link>
                  </div>
                  <div className="textFooter contact pb-2">
                    <Link to={`/${assignedLibrary}/cookies`} className="nav-link" onClick={goUp}>
                      <p className="contactDetails">Cookies</p>
                    </Link>
                  </div>
                </Col>
                <Col className="lastSection" xs={12} sm={12} md={6} xl={3}>
                  <h5 className="title-footer">{t('aceptamosMultiples')}</h5>
                  <div>
                    <img src={creditCards} alt="cards.png" />
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="w-100">
            <Col lg={12} className="bottom-footer">
              <div className="text-center m-2">
                <img src={logoMinistry} alt="corporations" className="corporations-logo" />
              </div>
              <Row className="copyright">
                <div className="markup" dangerouslySetInnerHTML={createMarkup()} />
              </Row>
            </Col>
          </div>
        </>
      )}
    </footer>
  );
};

Footer.propTypes = {
  helpTextList: PropTypes.array,
};

export default Footer;
